import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { Instance } from 'mobx-state-tree';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import MultiCalendar, { dateFormatMultiCalendar, MultiCalendarSelectionType } from '../common/MultiCalendar';
import { Pharmacy } from '../../store/models/Pharmacy';
import { DutyAssignment } from '../../store/models/DutyAssignment';
import { BlackPoint } from '../../store/models/BlackPoint';
import moment from 'moment';
import { BankHolidayDate } from '../../store/models/BankHolidayDate';
import { DutyOffRequest } from '../../store/models/DutyOffRequest';
import { Button, Intent, Label, TextArea } from '@blueprintjs/core';
import { TLCode } from '../../common/enums';
import styled from '@emotion/styled';
import LeaveRouteDirtyWrapper from '../common/LeaveRouteDirtyWrapper';
import { SystemStatus } from '../../store/models/SystemStatus';
import { NumberFilter } from 'ag-grid-community';
import { UiStore, ModalStore, AuthenticationStore, PharmacyDetailedStore, PharmacyStore } from '../../store';
import { Link } from 'react-router-dom';
import { Page } from '../../common/enums';
import { TranslatedMessage } from '../common/translation';
import ReactToPrint from 'react-to-print';
import { User } from '../../store/models/User';
import { PharmacyDetails } from '../../store/models';

const CommentDiv = styled.div`
  display: flex;
  flex-direction: row;
  width: 60%;
  // height: 50px;
`;

const FormDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 95%;
  margin-top: 10px;
`;

const DivRight = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 5px;
  .bp3-icon {
    margin-right: 3px;
  }
  margin-left: auto;
`;

interface PharmacyDutiesCalendarProps extends WithTranslateProps {
  bankHolidayDateList: Array<Instance<typeof BankHolidayDate>>;
  blackPointList: Array<Instance<typeof BlackPoint>>;
  dutyAssignments: Array<Instance<typeof DutyAssignment>>;
  dutyOffRequests: Array<Instance<typeof DutyOffRequest>>;
  pharmacyDetails?: Instance<typeof PharmacyDetails>;
  saveCalendarChange: (data: any) => void;
  onCalendarMove?: (fly: number, sly: number) => void;
  pharmacyId?: number;
  systemStatus: Array<Instance<typeof SystemStatus>>;
  isSecretariat?: boolean;
  fly: number;
  sly: number;
  rowCount?: number;
  hideLegend?: boolean;
  synchronizedScrolling?: boolean;
  UiStore?: Instance<typeof UiStore>;
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  PharmacyStore?: Instance<typeof PharmacyDetailedStore>;
  onTypeChange?: (type: MultiCalendarSelectionType | undefined) => void;
  selectedType?: MultiCalendarSelectionType | undefined;
  separateToolbox?: boolean;
  pharmacyList?: any;
  onPharmacyChange?: (selectedOption: any) => void;
  inMultiCalendar?: boolean;
  ModalStore?: Instance<typeof ModalStore>;
  userList?: Array<Instance<typeof User>>;
}

interface PharmacyDutiesCalendarState {
  newBlackPoints: string[];
  newBlackPointsEconomic: string[];
  newBlackPointsHealth: string[];
  newBlackPointsSpecial: string[];
  newDayDuties: string[];
  newDayNightDuties: string[];
  deletedBlackPoints: string[];
  deletedBlackPointsEconomic: string[];
  deletedBlackPointsHealth: string[];
  deletedBlackPointsSpecial: string[];
  deletedDutyOffRequests: string[];
  deletedDayDuties: string[];
  deletedDayNightDuties: string[];
  deletedNightDuties: string[];
  deletedExemptions: string[];
  comment: string;
  selectedType?: MultiCalendarSelectionType;
  user?: any;
  pharmacy?: Instance<typeof Pharmacy>;
}

@inject('UiStore', 'AuthenticationStore', 'PharmacyStore')
@observer
class PharmacyDutiesCalendar extends React.Component<PharmacyDutiesCalendarProps, PharmacyDutiesCalendarState> {
  state = {
    deletedBlackPoints: [],
    deletedBlackPointsEconomic: [],
    deletedBlackPointsHealth: [],
    deletedBlackPointsSpecial: [],
    deletedDutyOffRequests: [],
    deletedDayDuties: [],
    deletedDayNightDuties: [],
    deletedNightDuties: [],
    deletedExemptions: [],
    newBlackPoints: [],
    newBlackPointsEconomic: [],
    newBlackPointsHealth: [],
    newBlackPointsSpecial: [],
    newDayDuties: [],
    newDayNightDuties: [],
    comment: '',
    selectedType: this.props.selectedType ? this.props.selectedType : undefined,
    user: this.props.userList
      ? this.props.userList!.filter((u) => u.userId == this.props.pharmacyDetails!['userId'])[0]
      : undefined,
    pharmacy: undefined,
  } as PharmacyDutiesCalendarState;

  async componentDidMount() {
    if (this.props.pharmacyId) {
      await this.props.PharmacyStore!.ensureLoaded(this.props.pharmacyId);
      const pharmacy = this.props.PharmacyStore!.getById(this.props.pharmacyId)!;
      this.setState({ pharmacy: pharmacy });
    }
  }

  onTypeChange = (type: MultiCalendarSelectionType) => {
    if (this.state.selectedType !== type) {
      this.setState({ selectedType: type });
      if (this.props.onTypeChange) this.props.onTypeChange(type);
    }
  };

  onDatesChange = (changedData: any) => {
    console.log('ChangedData ', changedData);
    console.log('State', this.state);
    this.setState({ ...changedData });
  };

  onCalendarMove = (fly: number, sly: number) => {
    this.props.UiStore!.setPharmacyCalendarYear(fly);
    if (this.props.onCalendarMove) this.props.onCalendarMove(fly, sly);
  };

  blackPointReducer = (dates: string[], blackPoint) => {
    const date = moment(blackPoint.startDate).startOf('day');
    while (date.isBefore(moment(blackPoint.endDate).endOf('day'))) {
      dates.push(date.format(dateFormatMultiCalendar));
      date.add(1, 'd');
    }
    return dates;
  };

  cancelChange = () => {
    this.setState({
      deletedBlackPoints: [],
      deletedBlackPointsHealth: [],
      deletedBlackPointsEconomic: [],
      deletedBlackPointsSpecial: [],
      deletedDutyOffRequests: [],
      deletedDayDuties: [],
      deletedDayNightDuties: [],
      deletedNightDuties: [],
      deletedExemptions: [],
      newBlackPoints: [],
      newBlackPointsHealth: [],
      newBlackPointsEconomic: [],
      newBlackPointsSpecial: [],
      newDayDuties: [],
      newDayNightDuties: [],
      comment: '',
    });
  };

  saveChange = async () => {
    const {
      deletedBlackPoints,
      deletedBlackPointsEconomic,
      deletedBlackPointsHealth,
      deletedBlackPointsSpecial,
      deletedDutyOffRequests,
      deletedDayDuties,
      deletedDayNightDuties,
      deletedNightDuties,
      deletedExemptions,
      newBlackPoints,
      newBlackPointsEconomic,
      newBlackPointsHealth,
      newBlackPointsSpecial,
      newDayDuties,
      newDayNightDuties,
      comment,
    } = this.state;
    const data = {
      deletedBlackPointsHoliday: deletedBlackPoints.map((elem) => moment(elem).format()),
      deletedBlackPointsHealth: deletedBlackPointsHealth.map((elem) => moment(elem).format()),
      deletedBlackPointsEconomic: deletedBlackPointsEconomic.map((elem) => moment(elem).format()),
      deletedBlackPointsSpecial: deletedBlackPointsSpecial.map((elem) => moment(elem).format()),
      deletedDutyOffRequests: deletedDutyOffRequests.map((elem) => moment(elem).format()),
      deletedDayDuties: deletedDayDuties.map((elem) => moment(elem).format()),
      deletedDayNightDuties: deletedDayNightDuties.map((elem) => moment(elem).format()), // deletedDayDuties.map((elem) => moment(elem).format()),
      deletedNightDuties: deletedNightDuties.map((elem) => moment(elem).format()), // deletedDayDuties.map((elem) => moment(elem).format()),
      deletedExemptions: deletedExemptions.map((elem) => moment(elem).format()),
      newBlackPointsHoliday: newBlackPoints.map((elem) => moment(elem).format()),
      newBlackPointsHealth: newBlackPointsHealth.map((elem) => moment(elem).format()),
      newBlackPointsEconomic: newBlackPointsEconomic.map((elem) => moment(elem).format()),
      newBlackPointsSpecial: newBlackPointsSpecial.map((elem) => moment(elem).format()),
      newDayDuties: newDayDuties.map((elem) => moment(elem).format()),
      newDayNightDuties: newDayNightDuties.map((elem) => moment(elem).format()),
      comment,
      pharmacyId: this.props.pharmacyId,
    };

    try {
      this.props.saveCalendarChange(data);
      this.cancelChange();
    } catch (e) {
      console.log('Error', e);
    }
  };

  getIsDirty = () => {
    const {
      newBlackPointsEconomic,
      newBlackPoints,
      newBlackPointsHealth,
      newBlackPointsSpecial,
      newDayDuties,
      newDayNightDuties,
      deletedBlackPointsEconomic,
      deletedBlackPointsHealth,
      deletedBlackPointsSpecial,
      deletedBlackPoints,
      deletedDutyOffRequests,
      deletedDayDuties,
      deletedDayNightDuties,
      deletedNightDuties,
      comment,
    } = this.state;

    return (
      newBlackPoints.length > 0 ||
      newBlackPointsHealth.length > 0 ||
      newBlackPointsEconomic.length > 0 ||
      newBlackPointsSpecial.length > 0 ||
      newDayDuties.length > 0 ||
      newDayNightDuties.length > 0 ||
      deletedBlackPointsEconomic.length > 0 ||
      deletedBlackPointsHealth.length > 0 ||
      deletedBlackPointsSpecial.length > 0 ||
      deletedBlackPoints.length > 0 ||
      deletedDutyOffRequests.length > 0 ||
      deletedDayDuties.length > 0 ||
      deletedDayNightDuties.length > 0 ||
      deletedNightDuties.length > 0 ||
      comment !== ''
    );
  };

  canEditPharmacy = () => {
    const pharmacy =
      this.props.pharmacyId !== undefined
        ? this.props.PharmacyStore!.getById(this.props.pharmacyId)
        : this.state.pharmacy;
    return (
      this.props.AuthenticationStore!.isSuperAdmin ||
      ((pharmacy !== undefined &&
        (this.props.AuthenticationStore!.isSecretariat &&
          this.props.AuthenticationStore!.secretariatId === pharmacy!.secretariatId)) ||
        (this.props.AuthenticationStore!.isPharmacy && pharmacy!.apbNumber == this.props.AuthenticationStore!.userName))
    );
  };

  componentRef;

  render() {
    const {
      bankHolidayDateList,
      dutyAssignments,
      dutyOffRequests,
      blackPointList,
      pharmacyDetails,
      translate,
      systemStatus,
      isSecretariat,
      fly,
      rowCount,
      UiStore,
      hideLegend,
      synchronizedScrolling,
      ModalStore,
    } = this.props;
    const {
      deletedBlackPoints,
      deletedBlackPointsEconomic,
      deletedBlackPointsHealth,
      deletedBlackPointsSpecial,
      deletedDutyOffRequests,
      deletedDayDuties,
      deletedNightDuties,
      deletedDayNightDuties,
      deletedExemptions,
      newBlackPoints,
      newBlackPointsEconomic,
      newBlackPointsHealth,
      newBlackPointsSpecial,
      newDayDuties,
      newDayNightDuties,
    } = this.state;

    // console.log('>>> RENDER PharmacyDutiesCalendar ['+this.props.fly+']['+this.props.pharmacyId+')]');

    const pharmacyFirstLineYear = this.props.fly ? fly : UiStore!.pharmacyFirstLineYear;

    let dayDutyDates = dutyAssignments
      .filter((da) => {
        return da.duty!.dutyType !== undefined && da.duty!.dutyType.type === 'DAY';
      })
      .map((ass) => {
        return moment(ass.duty!.dutyDate.date).format(dateFormatMultiCalendar);
      });
    let nightDutyDates = dutyAssignments
      .filter((da) => {
        return da.duty!.dutyType!.type === 'NIGHT';
      })
      .map((ass) => {
        return moment(ass!.duty!.dutyDate.date).format(dateFormatMultiCalendar);
      });
    const dayNightDutyDates = dayDutyDates.filter((date) => {
      return nightDutyDates.includes(date);
    });
    dayDutyDates = dayDutyDates.filter((date) => {
      return !dayNightDutyDates.includes(date);
    });
    nightDutyDates = nightDutyDates.filter((date) => {
      return !dayNightDutyDates.includes(date);
    });

    const blackPoints1 = blackPointList
      .filter((b) => {
        return b.type !== undefined && b.type!.code === 'HOLIDAY';
      })
      .reduce(this.blackPointReducer, []);
    const blackPoints = [...Array.from(new Set<string>(blackPoints1))];

    const blackPointsEconomic1 = blackPointList
      .filter((b) => {
        return b.type !== undefined && b.type!.code === 'ECONOMIC';
      })
      .reduce(this.blackPointReducer, []);
    const blackPointsEconomic = [...Array.from(new Set<string>(blackPointsEconomic1))];

    const blackPointsHealth1 = blackPointList
      .filter((b) => {
        return b.type !== undefined && b.type!.code === 'SICK_LEAVE';
      })
      .reduce(this.blackPointReducer, []);
    const blackPointsHealth = [...Array.from(new Set<string>(blackPointsHealth1))];

    const blackPointsSpecial1 = blackPointList
      .filter((b) => {
        return b.type !== undefined && b.type!.code === 'SPECIAL';
      })
      .reduce(this.blackPointReducer, []);
    const blackPointsSpecial = [...Array.from(new Set<string>(blackPointsSpecial1))];

    const bankHolidayDates = bankHolidayDateList.map((elem) => moment(elem.date).format(dateFormatMultiCalendar));

    const dutyOffRequestDates = dutyOffRequests.map((elem) =>
      moment(elem.bankHolidayDate!.date).format(dateFormatMultiCalendar),
    );
    const dirty = this.getIsDirty();

    return (
      <div>
        <LeaveRouteDirtyWrapper blockChange={dirty} />
        <MultiCalendar
          ref={(el) => (this.componentRef = el)}
          rowCount={rowCount ? rowCount : 2}
          hideLegend={hideLegend}
          synchronizedScrolling={synchronizedScrolling}
          bankHolidayDates={bankHolidayDates}
          dayDuties={dayDutyDates}
          nightDuties={nightDutyDates}
          dayNightDuties={dayNightDutyDates}
          blackPoints={blackPoints}
          blackPointsEconomic={blackPointsEconomic}
          blackPointsHealth={blackPointsHealth}
          blackPointsSpecial={isSecretariat ? blackPointsSpecial : []}
          dutyOffRequestDates={dutyOffRequestDates}
          navigateMonthCount={12}
          newBlackPoints={newBlackPoints}
          newBlackPointsEconomic={newBlackPointsEconomic}
          newBlackPointsHealth={newBlackPointsHealth}
          newBlackPointsSpecial={newBlackPointsSpecial}
          newDayDuties={newDayDuties}
          newDayNightDuties={newDayNightDuties}
          deletedDutyOffRequests={deletedDutyOffRequests}
          deletedBlackPoints={deletedBlackPoints}
          deletedBlackPointsEconomic={deletedBlackPointsEconomic}
          deletedBlackPointsHealth={deletedBlackPointsHealth}
          deletedBlackPointsSpecial={deletedBlackPointsSpecial}
          deletedExemptions={deletedExemptions}
          // JLL
          deletedDayDuties={deletedDayDuties}
          deletedDayNightDuties={deletedDayNightDuties}
          deletedNightDuties={deletedNightDuties}
          onDatesChange={this.onDatesChange}
          onCalendarMove={this.onCalendarMove}
          systemStatus={systemStatus}
          blackPointHolidayMax={42}
          blackPointEconomicMax={14}
          annualFreeBankHolidayMax={3}
          annualFreeWeekendMax={22}
          isSecretariat={isSecretariat}
          fly={pharmacyFirstLineYear}
          sly={pharmacyFirstLineYear}
          pharmacyIdForDebugging={pharmacyDetails!.pharmacyId}
          onTypeChange={this.onTypeChange}
          selectedType={this.state.selectedType}
          separateToolbox={this.props.separateToolbox}
          pharmacyDetails={pharmacyDetails}
          pharmacyList={this.props.pharmacyList}
          pharmacyId={this.props.pharmacyId}
          onPharmacyChange={this.props.onPharmacyChange}
          ModalStore={ModalStore}
        />
        <FormDiv>
          {isSecretariat && this.state.user && (
            <a href={'mailto:' + this.state.user.email + '?subject=Pharmagarde - Message du Secrétariat de garde'}>
              {this.state.user.email}
            </a>
          )}
          {!isSecretariat && rowCount !== 1 && (
            <a
              href={
                'mailto: garde@uphoc.be?subject=Pharmagarde - Message de la pharmacie APB n°' +
                this.props.pharmacyDetails!.apbNumber
              }
            >
              Envoyer un email à votre secrétariat garde@uphoc.be
            </a>
          )}
          <DivRight>
            <div>
              {!this.props.inMultiCalendar && (
                <>
                  <ReactToPrint
                    documentTitle={'PlanningDeGarde-' + moment(new Date()).format('DD-MM-YYYY') + '.pdf'}
                    trigger={() => {
                      // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                      // to the root node of the returned component as it will be overwritten.
                      return <Button text={translate(TLCode.GENERAL_Print)} intent={Intent.PRIMARY} disabled={dirty} />;
                    }}
                    content={() => this.componentRef}
                  />
                  &nbsp;&nbsp;&nbsp;
                  <Button intent={Intent.NONE} disabled={false} style={{ marginRight: '35px' }}>
                    <Link
                      to={{
                        pathname: `${Page.CalendarComparisonPage}`,
                        search: '?sort=id',
                        hash: '#anchor',
                        state: { fromDashboard: true },
                      }}
                    >
                      <TranslatedMessage id={TLCode.CALENDAR_COMPARISON_PAGE} />
                    </Link>
                  </Button>
                </>
              )}
              <Button
                text={translate(TLCode.GENERAL_Cancel)}
                intent={Intent.PRIMARY}
                disabled={!dirty}
                onClick={() => this.cancelChange()}
              />
              <Button
                text={translate(TLCode.GENERAL_Save)}
                intent={Intent.PRIMARY}
                disabled={!dirty || !this.canEditPharmacy()}
                onClick={() => this.saveChange()}
                style={{ marginLeft: '5px' }}
              />
            </div>
          </DivRight>
        </FormDiv>
      </div>
    );
  }
}

export default withTranslate(PharmacyDutiesCalendar);
